import { render } from "./AccueilDesktop.vue?vue&type=template&id=49ea6a26&scoped=true"
import script from "./AccueilDesktop.vue?vue&type=script&lang=js"
export * from "./AccueilDesktop.vue?vue&type=script&lang=js"

import "./AccueilDesktop.vue?vue&type=style&index=0&id=49ea6a26&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ea6a26"]])

export default __exports__